export default __webpack_public_path__ + "static/screenshot-4-0f28f816d2d4404d264c0eeaf845bc4c.png";